module.exports = __webpack_public_path__ + "img/1-227x76.99ba5ae8.png";